var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13.75C12.34 13.75 12 13.41 12 13V7.75C12 7.34 12.34 7 12.75 7C13.16 7 13.5 7.34 13.5 7.75V13C13.5 13.41 13.16 13.75 12.75 13.75Z",
    fill: "#FFCF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 17.2502C12.48 17.2502 12.23 17.1502 12.04 16.9602C11.95 16.8602 11.88 16.7502 11.82 16.6302C11.77 16.5102 11.75 16.3802 11.75 16.2502C11.75 15.9902 11.86 15.7302 12.04 15.5402C12.41 15.1702 13.09 15.1702 13.46 15.5402C13.64 15.7302 13.75 15.9902 13.75 16.2502C13.75 16.3802 13.72 16.5102 13.67 16.6302C13.62 16.7502 13.55 16.8602 13.46 16.9602C13.27 17.1502 13.02 17.2502 12.75 17.2502Z",
    fill: "#FFCF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 22.7501C12.0802 22.7501 11.4002 22.5801 10.8002 22.2301L4.86017 18.8001C3.66017 18.1001 2.91016 16.8101 2.91016 15.4201V8.58011C2.91016 7.19011 3.66017 5.90011 4.86017 5.20011L10.8002 1.77012C12.0002 1.07012 13.4902 1.07012 14.7002 1.77012L20.6402 5.20011C21.8402 5.90011 22.5902 7.19011 22.5902 8.58011V15.4201C22.5902 16.8101 21.8402 18.1001 20.6402 18.8001L14.7002 22.2301C14.1002 22.5801 13.4202 22.7501 12.7502 22.7501ZM12.7502 2.7501C12.3402 2.7501 11.9202 2.8601 11.5502 3.0701L5.61017 6.5001C4.87017 6.9301 4.41016 7.72011 4.41016 8.58011V15.4201C4.41016 16.2701 4.87017 17.0701 5.61017 17.5001L11.5502 20.9301C12.2902 21.3601 13.2102 21.3601 13.9402 20.9301L19.8802 17.5001C20.6202 17.0701 21.0802 16.2801 21.0802 15.4201V8.58011C21.0802 7.73011 20.6202 6.9301 19.8802 6.5001L13.9402 3.0701C13.5802 2.8601 13.1602 2.7501 12.7502 2.7501Z",
    fill: "#FFCF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning3);
export default __webpack_public_path__ + "static/media/warning-3.a80d67c7e9ae3d1b003c190fc1c6d5f7.svg";
export { ForwardRef as ReactComponent };